import React, { Component } from 'react';
import * as util from '../../../../../utils/EnumMapping';
import MainTable from '../../../../common/table/MainTable';
import NewVacation from './NewVacation';
import * as columns from './VacationColumns';
import { tabs } from '../VacationUtil';
import LinkTab from '../../../../common/tab/TabNav.js';
class Vacation extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "VACATION";
            item.typeLabel = util.getLabel(util.vacationTypes, item.type);
            return item;
        })
        return data;
    }

    render() {
        return (
            <>
                <LinkTab tabs={tabs} index={1} />
                <MainTable
                    divClassName="vacation"
                    tableName="Szabadságok"
                    newObjectLabel="Új szabadság hozzáadása"
                    path='/api/vacations'
                    enrich={this.enrich}
                    columns={(props) => columns.columns(props)}
                    dialogContent={(refresh, close) => <NewVacation refresh={refresh} close={close} />} />
            </>
        );
    }
}

export default Vacation;